import { ValuationGapDto } from "../../models/Dashboard";
import "./DashboardStyleSheet.css";

const ValuationGapsCard: React.FC<{ gaps: ValuationGapDto[] }> = ({ gaps }) => (
    <div className="dashboard-card">
        <div className="dashboard-card-header"><h2>Valuation Gaps</h2></div>
        <div className="dashboard-card-body">
            {gaps.length === 0 && (
                <p className="empty-state">No significant gaps detected.</p>
            )}
            <table className="data-table">
                <thead>
                    <tr>
                        <th>Work</th>
                        <th className="text-right">FMV</th>
                        <th className="text-right">Insured</th>
                        <th className="text-right">Gap</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {gaps.map(g => (
                        <tr key={g.artworkId}>
                            <td>
                                <div className="cell-title">{g.title}</div>
                                <div className="cell-sub">{g.artistName}</div>
                            </td>
                            <td className="text-right">{g.valueFormatted}</td>
                            <td className="text-right">{g.insFormatted}</td>
                            <td className="text-right">{g.gapFormatted}</td>
                            <td>
                                <span className={`badge badge--${g.gapDirection === "under-insured" ? "warning" : "info"
                                    }`}>
                                    {g.gapDirection}
                                </span>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    </div>
);
export default ValuationGapsCard;